<template>
<div class="chapter">
<div class="inner_page">
<p class="chaptitle" id="not">Author’s Note</p>
<p class="noindent">I was assigned to the Indochina Branch after returning from Europe on my first assignment as an intelligence officer. I was supposed to go directly to the Far East in the summer of 1954 but was assigned to the Vietnam desk and subsequently the newly created Cambodia/Laos desk. About a year later, I went out to the field in covert operations for the Indochina Branch. Not once did I hear from official sources of the extensive contact that Office of Strategic Services (OSS) had had with Ho Chi Minh and other leaders of the Viet Minh. I learned about that years later. It was a matter never discussed during the 1950s and never taken advantage of in the 1960s. This book is about that period in spring/summer 1945 when the principal American intelligence organization of that time, the OSS, was in close and cooperative contact with Ho Chi Minh, personally, and fighting cadre of the Viet Minh, organizationally. These were the last and very dangerous days of World War II and the battle against the Japanese.</p>
<p class="indent">While this story is told in the form of a novel, it nonetheless is based on actual events and exploits of various OSS officers and enlisted men. I have chosen to fictionalize these individuals because so many of them sought in later years to avoid public awareness of their roles in northern Vietnam and their working relationship with Ho Chi Minh and his staff in the field. Similarly, for literary purposes, I have combined the activities of several of the teams and their operational leaders. I have tried to remain true to the action and the situation of the history of the operation. These missions and the events which drove them occurred some 20 years before the Gulf of Tonkin Resolution that marked the justification for the escalation of American involvement in Vietnam.</p>
<p class="indent">There was a time.</p>
<p class="right">George H. Wittman</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_author_note.vue?7e918e47